import Merge from '@/pages/merge'
import { ChatAgentCardList, ChatBubblePromptsCard, ChatBoxItem } from '@sui/chat-ui'
//@ts-ignore
import { ReactComponent as SendFly } from '@sui/chat-ui/lib/assets/svgs/sendFly.svg'
import { QuestionCircleFilled, ReloadOutlined } from '@ant-design/icons'
import React, { useEffect, useState, useRef } from 'react'
//@ts-ignore
import AppIcon5 from '@sui/chat-ui/lib/assets/apps/app_icon5.png'
//@ts-ignore
import AppIcon6 from '@sui/chat-ui/lib/assets/apps/app_icon6.png'
import { Button, Skeleton } from 'antd';
import { Link } from '@sui/runtime';
import { getChatUrl, isMobile } from "@/utils/public";
import "./index.less";
import {
  getInitData,
  API
} from "@/api/index";
import useBaseRequest from "@/hooks/useBaseRequest";
import Question from "../../../assets/images/question.png";
import axios from 'axios';

export default function agent() {

  const [newData, setNewData] = useState([])
  const [newInit, setNewInit] = useState(false)
  const [initObj, setInitObj] = useState({})
  const [refresh, setRefresh] = useState("")
  const [newZntData, setNewZntData] = useState([])

  console.log(isMobile, "移动端嘛？")


  useEffect(() => {
    axios.all([getInitData(), getZntDatas()]).then(axios.spread((res, res1) => {
      console.log("宁波理工===", res1)
      const data = res?.data?.result?.data;
      const data1 = res1?.data?.result?.data || [];
      const arr = []
      const arr1 = []
      data.hotqas?.map((item) => {
        arr.push({
          key: item.id,
          description: item.name
        })
      })

      data1.map((item) => {
        if (item.id * 1 === 4 || item.id * 1 === 5) {
          arr1.push({
            name: item.name,
            description: item.summary,
            icon: item.icon,
            id: item.id
          })
        }

      })
      setNewInit(true)
      setNewData(arr)
      setInitObj(data)
      setNewZntData(arr1)



      if (!data?.userId && data?.forcelogin === 1) {
        if (process.env.NODE_ENV === "development") {
          return;
        }
        const baseUrl = window.location.protocol + "//" + window.location.host;
        const hash = window.location.hash;
        console.log(hash, "检验用户是否登录的hash");
        const url = new URL(data?.loginUrl, baseUrl)
        if (window.location.href.includes("#/newChat")) {
          if (hash) {
            window.sessionStorage.setItem("hash", hash)
          }
          window.location.href = url.toString()
        } else {
          window.location.href = data?.loginUrl
        }

      } else {
        const newhash = window.sessionStorage.getItem("hash")
        if (newhash) {
          if (window.location.href.includes("#/newChat")) {
            window.sessionStorage.removeItem("hash");
            window.location.href = window.location.href
            return
          }
          window.location.href = window.location.href + newhash;

        }
        console.log(window.location.hash, "检验用户是否登录的hash");
      }
    }))
  }, [refresh])

  const getInitData = () => {
    return axios.get(API.serInit)
  }

  const getZntDatas = () => {
    return axios.get(API.categaryList)
  }


  return (
    newInit ? <Merge portalLayout fixedName={initObj?.name} single headless={false} hideHeader hideSider chatBoxProps={{
      noborder: true,
      coolDownColor: true,
      alphaInput: 9,
      minRows: isMobile() ? 2 : 6,
      sendIcon: <span style={{ display: 'block', height: 14 }}><SendFly /></span>,
      welcome: {
        alignCenter: false,
        layout: 'horizontal',
        // title: '您好，我是AI智能助手，我会尽力帮您查找内容!期待与您互动哦~',
        title: '',
        icon: false,
        // description: "收到付款水单律师代理费",
        content: <div style={{ fontSize: '16px', color: '#528ED4', lineHeight: '24px', padding: "8px 0" }}>我是宁理智答，帮助您在学习、生活、工作等方面的答疑解惑。为了保护个人隐私，请避免提问敏感信息。</div>
      },
      prefixIcon: false,
      welcomeWrapStyle: {
        paddingBottom: 0
      },
      renderAfterSenderBox(mode) {
        return null
      },
      onSubmit: (ctx, val) => {
        setRefresh(Math.random())
        window.open(getChatUrl(ctx?.data?.id, false, false, encodeURIComponent(val)), '_agent')
      },
      renderAfterWelcome(ctx) {
        return <ChatBoxItem style={{ flex: 1 }} gap={24}>
          <ChatAgentCardList onClickItem={(e, item) => {
            //  ctx.changeAgent?.(item.id)
            window.open(getChatUrl(item.id, false, false, ""), '_agent')
          }}
            // items={[
            //   {
            //     name: "图书馆问答助手",
            //     description: "您好，我是图书馆AI问答助手，帮助您在图书馆业务方面的答疑解惑。为了保护个人隐私，请避免提问敏感信息。",
            //     icon: AppIcon5,
            //     id: '4'
            //   },
            //   {
            //     name: "采购问答助手",
            //     description: "您好，我是采购AI问答助手，帮助您在采购问题方面的答疑解惑。为了保护个人隐私，请避免提问敏感信息。",
            //     icon: AppIcon6,
            //     id: '5'
            //   }
            // ]}
            items={newZntData}
          />
          <div style={{ margin: "0px 6px", textAlign: "right" }}>
            <Link to="/newSearch" style={{ color: '#f97c37', fontSize: 14 }}>更多智能体&gt;</Link>
          </div>
          {!ctx.promptsItems?.length ? null : <ChatBubblePromptsCard shape='round' extra={
            ctx.data?.hotqas?.length > 6 ? (
              <Button
                onClick={ctx.reloadHots}
                style={{ color: "inherit" }}
                type="text"
                icon={<ReloadOutlined />}
              ></Button>
            ) : null
          } icon={<img src={Question} style={{
            width: "18px",
            height: "20px"
          }} alt="" />} arrowType='swapright' size='default' type='primary' column={2} gap={[16, 24]} title='推荐问题' onItemClick={info => {
            console.log(info);
            // ctx.chat(info.data.title?.toString());
            setRefresh(Math.random())
            window.open(getChatUrl(initObj?.id, false, false, encodeURIComponent(info?.data?.title)), '_agent')
          }}
            items={newData}
          />}
        </ChatBoxItem>
      },
    }} /> : <Skeleton />
  )
}
